import { type HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils/tailwind';

type ModalHeaderProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

const ModalHeader = ({ children, className, ...props }: ModalHeaderProps) => {
  return (
    <div
      className={cn(
        ['flex items-center justify-between p-4 border-b border-border'],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export { ModalHeader };
